function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.0009 91.2342C70.9826 91.2342 91.2342 70.9826 91.2342 46.0009C91.2342 21.0192 70.9826 0.767578 46.0009 0.767578C21.0192 0.767578 0.767578 21.0192 0.767578 46.0009C0.767578 70.9826 21.0192 91.2342 46.0009 91.2342Z",
  fill: "#D3D3D3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.8306 45.9988L25.748 64.0814L27.9165 66.2498L45.9991 48.1673L64.0816 66.2498L66.2501 64.0814L48.1675 45.9988L66.2498 27.9165L64.0814 25.748L45.9991 43.8304L27.9167 25.748L25.7483 27.9165L43.8306 45.9988Z",
  fill: "white"
});

function SvgGreyFailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFailIcon);
export default __webpack_public_path__ + "static/media/GreyFailIcon.e07d86374cfa70205877a0892af40258.svg";
export { ForwardRef as ReactComponent };